import React, { useState } from "react";

export const FilterPanel = ({
  onClose,
  onApplyFilters
}) => {

  const [sortBy, setSortBy] = useState("content_last_updated_on.date"); // Default sort field
  const [sortOrder, setSortOrder] = useState("desc"); // Default sort order

  console.log("FilterPanel Loaded!"); // Confirm component renders
  // console.log("onApplyFilters:", onApplyFilters); // Check if function is received


  const applyFilters = () => {
    console.log("Apply Filters Clicked!"); // Confirm button click
    console.log("Applying Filters with:", sortBy, sortOrder);
    onApplyFilters(sortBy, sortOrder);
    onClose();
  };

  return (
    <div className='panel_filter_full_height'>
      <div className='close_filter_and_clear_filters'>
        {/* <div className='clear_filter'>Clear Filters</div> */}
        <div onClick={onClose} className='clear_filter_icon'><i className="fa fa-times" aria-hidden="true"></i></div>
        {/* Apply Button */}
        <button className='clear_filter' onClick={applyFilters}>Apply Filters</button>
      </div>
      {/* <div className='date_filter_main_container'>
              <div className='date_filter_label'>Sort by date</div>
              <div className='date_form_container'>
                  <div className='date_label'>Start Date</div>
                  <div className='date_input'>
                      <Input type='date' name='start_date' />
                  </div>
              </div>
              <div className='date_form_container'>
                  <div className='date_label'>End Date</div>
                  <div className='date_input'>
                      <Input type='date' name='end_date' />
                  </div>
              </div>
          </div> */}

      {/* Sorting Options */}
      {/* <div className="sorting_main_filter_container">
        <div className="sorting_filter_label">Sort by:</div>
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="content_last_updated_on.date">Date Updated</option>
          <option value="title">Title</option>
          <option value="author">Author</option>
        </select>
      </div> */}

      {/* <div className="sorting_order_filter_container">
        <div className="sorting_order_label">Order:</div>
        <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div> */}
      <div className='publication_main_filter_container'>
        <div className='publication_filter_label'>Sort by Date updated
          <div className='sort_by_publication_container'>
            {/* <div className="sorting_filter_label">Sort by:</div> */}
            {/* <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="content_last_updated_on.date">Date Updated</option>
          <option value="title">Title</option>
          <option value="author">Author</option>
        </select> */}

            <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
          </div>
        </div>
      </div>
      {/* <div className='category_main_filter_container'>
        <div className='category_filter_label'>Sort by Category</div>
        <div className='sort_by_category_container'>

        </div>
      </div> */}
    </div>
  )
}